import { NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  input,
  output,
  signal
} from '@angular/core';
import { PathwayCourse } from '@cpd-app/core-module/models';
import { SponsorshipCompany } from '@cpd-app/generated';
import { ButtonModule } from '@cpd-app/shared-module/components/button/button.module';

@Component({
  selector: 'cpd-sponsor-course-card',
  templateUrl: './sponsor-course-card.component.html',
  styleUrls: ['./sponsor-course-card.component.scss'],
  standalone: true,
  imports: [ButtonModule, NgOptimizedImage],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SponsorCourseCardComponent {
  public readonly badges = signal<string[]>(['Online']);
  public readonly isExpand = signal<boolean>(false);

  public readonly sponsor = input<SponsorshipCompany>();
  public readonly cardInfo = input<PathwayCourse>();
  public readonly onCardClicked = output<void>();

  @HostListener('click')
  public cardClicked(): void {
    this.onCardClicked.emit();
  }

  public toggleExpand(event: Event): void {
    this.isExpand.update((isExpand) => !isExpand);
    event.stopPropagation();
  }
}
